import { Phone, MessageCircle } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { LINKS } from "../lib/assets";

export const MobileBar = () => {
  const { t } = useLang();
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-gold/40 lg:hidden" data-testid="mobile-action-bar">
      <a
        href={LINKS.tel}
        data-testid="mobile-call-btn"
        className="flex items-center justify-center gap-2 bg-navy py-4 text-sm font-medium text-ivory"
      >
        <Phone size={16} className="text-gold" />
        {t.common.callSchool}
      </a>
      <a
        href={LINKS.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-whatsapp-btn"
        className="flex items-center justify-center gap-2 bg-gold py-4 text-sm font-medium text-navy"
      >
        <MessageCircle size={16} />
        {t.common.whatsapp}
      </a>
    </div>
  );
};
